
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexDecBXwsEno6B2HPzW_45zQx3Rw9i_45LmBm166IjLBnE_45_YMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/index.vue?macro=true";
import { default as input4PdhuWE0OdSmcp_I849fdetN1Vf04rbgxjvJ2l2VT_0Meta } from "D:/W2/CDVM_V2/VM.Cms/pages/input.vue?macro=true";
import { default as builderINnyu0RODkl5YDMkyIRoNpmLBO2bsEReCfiYq0ZfpVAMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/builder.vue?macro=true";
import { default as indexI7mz3AHf4l9Npp_0KqUr4_QxDxRuXtS_45NwG4tfwzU5wMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/role/index.vue?macro=true";
import { default as indexnCPls_XJBD2HuX4Ce_45FoUOZw3wJzZjlttNeJDxXRJrMMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/class/index.vue?macro=true";
import { default as index617RjVtj8LOoGHibebhHi0SROLznZmkSvRghZyBzw3gMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/config/index.vue?macro=true";
import { default as parent_45inputEUtyEj6JWOYEm_45MwjO1CnyjFENZ7bCqkedNa6VQNiA4Meta } from "D:/W2/CDVM_V2/VM.Cms/pages/parent-input.vue?macro=true";
import { default as indexYnZ4fC9WNrcKm5tG6gdB6y_45BGkHEAr_45S8P_9qZl61HQMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/account/index.vue?macro=true";
import { default as login_JfaM1nKnO5BVRf4D7JCxGy6mzedZx3BtOXj5pP7W5kMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/account/login.vue?macro=true";
import { default as indexEWk32zYLWblRfkvndRCSLRrTTmAttr_45dgtxvYa3Rb3sMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/receipt/index.vue?macro=true";
import { default as indexGYXy8NCmHi_HmSMsM0cjRlfklrcpEpwIQP6BXWbd6_oMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/student/index.vue?macro=true";
import { default as pdf2imagexmtpEhR_bM_JnRaSwREMf_xj6tgS7SVAMT3ulmI2EdQMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/test/pdf2image.vue?macro=true";
import { default as _91type_93lAbcONKR9_CLFbIFUtd7CiyrUv46rC2atOKVBjLRSGkMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/category/[type].vue?macro=true";
import { default as toast_45demoRG7a5ZNA1OXFx_kdvfnSLD5OsJ0jOVApo0wEEHlUkLYMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/test/toast-demo.vue?macro=true";
import { default as settingsqixqSAzk_45IRGUnzapeDXbPPcIDhVhjdKa5_450Yq14W7QMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/account/settings.vue?macro=true";
import { default as file_45viewerwWWEwPYnjLpuLjYdTPOmuuBSPm2_AJgFTgiy51CVE_cMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/test/file-viewer.vue?macro=true";
import { default as file_45managerI2AY48Q0IqqCAjg2O1GhASeZKD_450cT5GRl9EQgMrCPMMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/test/file-manager.vue?macro=true";
import { default as indexI5TqSk2rd2Z63w3CJy1klMesBqNTa1_yM4g7J3hIgBoMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/activity-log/index.vue?macro=true";
import { default as indexi0rDIzCzdLaHOJs4Ov81iAbudOWXw3u8gURWHKs6gCoMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/bank-account/index.vue?macro=true";
import { default as indexe1_iBr_45NFTfWVGCTWXpQxAqdsP_45qaiW5zdwmYV4E3WwMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/fee-schedule/index.vue?macro=true";
import { default as indexKzCdA_45ksKkAKlq0muDkiotr53lUzaZZm72Uj02F5i_45EMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/scholar-ship/index.vue?macro=true";
import { default as index6m2pLGg12Z5vJohqxgOgHTLjUjKxYX5NXvUXE_45ulGMsMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/academic-year/index.vue?macro=true";
import { default as indexy0pLWBqeeDTuJMQR5_45JaJwUotDfdXtUNHtizGpVVsckMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/notifications/index.vue?macro=true";
import { default as index0oo89MpqxVDgOVdzsA_45BHHoEpwz5_yOr_45qUzcPLkpzYMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/score/conduct/index.vue?macro=true";
import { default as indexs7oHWKkj29kvXr0s_45eW_45V5OOByCbP7T82RXWUgKiEm8Meta } from "D:/W2/CDVM_V2/VM.Cms/pages/score/subject/index.vue?macro=true";
import { default as index0cgj_DGs6J6_T8udoChg3EAEAQ5TlPoBcaI3r22NkqAMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/student-print/index.vue?macro=true";
import { default as indexgnKX4Uspm_cu6mDuHdeNwmZECp7dY51Ys9cX9KvekAIMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/major-exemption/index.vue?macro=true";
import { default as indexBqMz1qbqx1n7csp1eGLqRlKWNsSXrcQl33qHc0p7UBwMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/score/component/index.vue?macro=true";
import { default as indexhqepX5Vur7C8pxLoi_DLfqbwDRNRBRx0ME8u30Zq_45kIMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/score/transcript/index.vue?macro=true";
import { default as forgot_45password_E4ighjvnxhhkaPA0h1ipQsnTXOnrXeAhwxLXWg7b7QMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/account/forgot-password.vue?macro=true";
import { default as indexqTKDrPk_Lo2dD0fdkYPB_IiR2II_V6ou7RfppEmIS_450Meta } from "D:/W2/CDVM_V2/VM.Cms/pages/tuition-exemption/index.vue?macro=true";
import { default as payment_45tracking_gH5S0e50_So7zIqdrosSvXTO3Ks9I0vg2TnK5pakMcMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/receipt/payment-tracking.vue?macro=true";
import { default as student_45statusbLScBVqFqrvSx8MxCy4fV5s_wjJ670_45CBOChi88jcMEMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/statistic/student-status.vue?macro=true";
import { default as index0ia6RTq9ogixFxhtx3_457W9EqX9zSOg6stDndPCDVkMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/score/subject-score/index.vue?macro=true";
import { default as _91token_93YMTd29myIDQi8kjP7frCFXTLlksqi_45wGAguwhXUNPigMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/parent-confirm-tuition/[token].vue?macro=true";
import { default as student_45notification_45demohEYx4ybZL6rPCEcpdoGpsERMy_45uOoNiVzvqh1a_45fyuYMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/test/student-notification-demo.vue?macro=true";
import { default as stats_45by_45wardbLVlSqZRyZQGKOJJlxr36Evoas26C1Aj3_45arfSMYX_45QMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/tuition-exemption/stats-by-ward.vue?macro=true";
import { default as student_45status_45summaryb9RMF2nb08dISelQup3nP1smxjsXzwbbBky5KjQ3skYMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/statistic/student-status-summary.vue?macro=true";
import { default as parent_45confirmR8N2LoDbEbMfOgPxlfalUrtMB_D9m9TbAgiUsCVPcNwMeta } from "D:/W2/CDVM_V2/VM.Cms/pages/tuition-exemption/parent-confirm.vue?macro=true";
import { default as student_45status_45summary_45oldwFrUs9zaRwRi0aY3L2aHJkEMkPisTtQbdxjef1o1lx0Meta } from "D:/W2/CDVM_V2/VM.Cms/pages/statistic/student-status-summary-old.vue?macro=true";
export default [
  {
    name: "index___vi",
    path: "/",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/index.vue")
  },
  {
    name: "input___vi",
    path: "/input",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/input.vue")
  },
  {
    name: "input___en",
    path: "/en/input",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/input.vue")
  },
  {
    name: "builder___vi",
    path: "/builder",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/builder.vue")
  },
  {
    name: "builder___en",
    path: "/en/builder",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/builder.vue")
  },
  {
    name: "role___vi",
    path: "/role",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/role/index.vue")
  },
  {
    name: "role___en",
    path: "/en/role",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/role/index.vue")
  },
  {
    name: "class___vi",
    path: "/class",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/class/index.vue")
  },
  {
    name: "class___en",
    path: "/en/class",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/class/index.vue")
  },
  {
    name: "config___vi",
    path: "/config",
    meta: index617RjVtj8LOoGHibebhHi0SROLznZmkSvRghZyBzw3gMeta || {},
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/config/index.vue")
  },
  {
    name: "config___en",
    path: "/en/config",
    meta: index617RjVtj8LOoGHibebhHi0SROLznZmkSvRghZyBzw3gMeta || {},
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/config/index.vue")
  },
  {
    name: "parent-input___vi",
    path: "/parent-input",
    meta: parent_45inputEUtyEj6JWOYEm_45MwjO1CnyjFENZ7bCqkedNa6VQNiA4Meta || {},
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/parent-input.vue")
  },
  {
    name: "parent-input___en",
    path: "/en/parent-input",
    meta: parent_45inputEUtyEj6JWOYEm_45MwjO1CnyjFENZ7bCqkedNa6VQNiA4Meta || {},
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/parent-input.vue")
  },
  {
    name: "account___vi",
    path: "/account",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/account/index.vue")
  },
  {
    name: "account___en",
    path: "/en/account",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/account/index.vue")
  },
  {
    name: "account-login___vi",
    path: "/account/login",
    meta: login_JfaM1nKnO5BVRf4D7JCxGy6mzedZx3BtOXj5pP7W5kMeta || {},
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/account/login.vue")
  },
  {
    name: "account-login___en",
    path: "/en/account/login",
    meta: login_JfaM1nKnO5BVRf4D7JCxGy6mzedZx3BtOXj5pP7W5kMeta || {},
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/account/login.vue")
  },
  {
    name: "receipt___vi",
    path: "/receipt",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/receipt/index.vue")
  },
  {
    name: "receipt___en",
    path: "/en/receipt",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/receipt/index.vue")
  },
  {
    name: "student___vi",
    path: "/student",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/student/index.vue")
  },
  {
    name: "student___en",
    path: "/en/student",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/student/index.vue")
  },
  {
    name: "test-pdf2image___vi",
    path: "/test/pdf2image",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/test/pdf2image.vue")
  },
  {
    name: "test-pdf2image___en",
    path: "/en/test/pdf2image",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/test/pdf2image.vue")
  },
  {
    name: "category-type___vi",
    path: "/category/:type()",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/category/[type].vue")
  },
  {
    name: "category-type___en",
    path: "/en/category/:type()",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/category/[type].vue")
  },
  {
    name: "test-toast-demo___vi",
    path: "/test/toast-demo",
    meta: toast_45demoRG7a5ZNA1OXFx_kdvfnSLD5OsJ0jOVApo0wEEHlUkLYMeta || {},
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/test/toast-demo.vue")
  },
  {
    name: "test-toast-demo___en",
    path: "/en/test/toast-demo",
    meta: toast_45demoRG7a5ZNA1OXFx_kdvfnSLD5OsJ0jOVApo0wEEHlUkLYMeta || {},
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/test/toast-demo.vue")
  },
  {
    name: "account-settings___vi",
    path: "/account/settings",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/account/settings.vue")
  },
  {
    name: "account-settings___en",
    path: "/en/account/settings",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/account/settings.vue")
  },
  {
    name: "test-file-viewer___vi",
    path: "/test/file-viewer",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/test/file-viewer.vue")
  },
  {
    name: "test-file-viewer___en",
    path: "/en/test/file-viewer",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/test/file-viewer.vue")
  },
  {
    name: "test-file-manager___vi",
    path: "/test/file-manager",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/test/file-manager.vue")
  },
  {
    name: "test-file-manager___en",
    path: "/en/test/file-manager",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/test/file-manager.vue")
  },
  {
    name: "activity-log___vi",
    path: "/activity-log",
    meta: indexI5TqSk2rd2Z63w3CJy1klMesBqNTa1_yM4g7J3hIgBoMeta || {},
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/activity-log/index.vue")
  },
  {
    name: "activity-log___en",
    path: "/en/activity-log",
    meta: indexI5TqSk2rd2Z63w3CJy1klMesBqNTa1_yM4g7J3hIgBoMeta || {},
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/activity-log/index.vue")
  },
  {
    name: "bank-account___vi",
    path: "/bank-account",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/bank-account/index.vue")
  },
  {
    name: "bank-account___en",
    path: "/en/bank-account",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/bank-account/index.vue")
  },
  {
    name: "fee-schedule___vi",
    path: "/fee-schedule",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/fee-schedule/index.vue")
  },
  {
    name: "fee-schedule___en",
    path: "/en/fee-schedule",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/fee-schedule/index.vue")
  },
  {
    name: "scholar-ship___vi",
    path: "/scholar-ship",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/scholar-ship/index.vue")
  },
  {
    name: "scholar-ship___en",
    path: "/en/scholar-ship",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/scholar-ship/index.vue")
  },
  {
    name: "academic-year___vi",
    path: "/academic-year",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/academic-year/index.vue")
  },
  {
    name: "academic-year___en",
    path: "/en/academic-year",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/academic-year/index.vue")
  },
  {
    name: "notifications___vi",
    path: "/notifications",
    meta: indexy0pLWBqeeDTuJMQR5_45JaJwUotDfdXtUNHtizGpVVsckMeta || {},
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/notifications/index.vue")
  },
  {
    name: "notifications___en",
    path: "/en/notifications",
    meta: indexy0pLWBqeeDTuJMQR5_45JaJwUotDfdXtUNHtizGpVVsckMeta || {},
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/notifications/index.vue")
  },
  {
    name: "score-conduct___vi",
    path: "/score/conduct",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/score/conduct/index.vue")
  },
  {
    name: "score-conduct___en",
    path: "/en/score/conduct",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/score/conduct/index.vue")
  },
  {
    name: "score-subject___vi",
    path: "/score/subject",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/score/subject/index.vue")
  },
  {
    name: "score-subject___en",
    path: "/en/score/subject",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/score/subject/index.vue")
  },
  {
    name: "student-print___vi",
    path: "/student-print",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/student-print/index.vue")
  },
  {
    name: "student-print___en",
    path: "/en/student-print",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/student-print/index.vue")
  },
  {
    name: "major-exemption___vi",
    path: "/major-exemption",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/major-exemption/index.vue")
  },
  {
    name: "major-exemption___en",
    path: "/en/major-exemption",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/major-exemption/index.vue")
  },
  {
    name: "score-component___vi",
    path: "/score/component",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/score/component/index.vue")
  },
  {
    name: "score-component___en",
    path: "/en/score/component",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/score/component/index.vue")
  },
  {
    name: "score-transcript___vi",
    path: "/score/transcript",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/score/transcript/index.vue")
  },
  {
    name: "score-transcript___en",
    path: "/en/score/transcript",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/score/transcript/index.vue")
  },
  {
    name: "account-forgot-password___vi",
    path: "/account/forgot-password",
    meta: forgot_45password_E4ighjvnxhhkaPA0h1ipQsnTXOnrXeAhwxLXWg7b7QMeta || {},
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/account/forgot-password.vue")
  },
  {
    name: "account-forgot-password___en",
    path: "/en/account/forgot-password",
    meta: forgot_45password_E4ighjvnxhhkaPA0h1ipQsnTXOnrXeAhwxLXWg7b7QMeta || {},
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/account/forgot-password.vue")
  },
  {
    name: "tuition-exemption___vi",
    path: "/tuition-exemption",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/tuition-exemption/index.vue")
  },
  {
    name: "tuition-exemption___en",
    path: "/en/tuition-exemption",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/tuition-exemption/index.vue")
  },
  {
    name: "receipt-payment-tracking___vi",
    path: "/receipt/payment-tracking",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/receipt/payment-tracking.vue")
  },
  {
    name: "receipt-payment-tracking___en",
    path: "/en/receipt/payment-tracking",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/receipt/payment-tracking.vue")
  },
  {
    name: "statistic-student-status___vi",
    path: "/statistic/student-status",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/statistic/student-status.vue")
  },
  {
    name: "statistic-student-status___en",
    path: "/en/statistic/student-status",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/statistic/student-status.vue")
  },
  {
    name: "score-subject-score___vi",
    path: "/score/subject-score",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/score/subject-score/index.vue")
  },
  {
    name: "score-subject-score___en",
    path: "/en/score/subject-score",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/score/subject-score/index.vue")
  },
  {
    name: "parent-confirm-tuition-token___vi",
    path: "/parent-confirm-tuition/:token()",
    meta: _91token_93YMTd29myIDQi8kjP7frCFXTLlksqi_45wGAguwhXUNPigMeta || {},
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/parent-confirm-tuition/[token].vue")
  },
  {
    name: "parent-confirm-tuition-token___en",
    path: "/en/parent-confirm-tuition/:token()",
    meta: _91token_93YMTd29myIDQi8kjP7frCFXTLlksqi_45wGAguwhXUNPigMeta || {},
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/parent-confirm-tuition/[token].vue")
  },
  {
    name: "test-student-notification-demo___vi",
    path: "/test/student-notification-demo",
    meta: student_45notification_45demohEYx4ybZL6rPCEcpdoGpsERMy_45uOoNiVzvqh1a_45fyuYMeta || {},
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/test/student-notification-demo.vue")
  },
  {
    name: "test-student-notification-demo___en",
    path: "/en/test/student-notification-demo",
    meta: student_45notification_45demohEYx4ybZL6rPCEcpdoGpsERMy_45uOoNiVzvqh1a_45fyuYMeta || {},
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/test/student-notification-demo.vue")
  },
  {
    name: "tuition-exemption-stats-by-ward___vi",
    path: "/tuition-exemption/stats-by-ward",
    meta: stats_45by_45wardbLVlSqZRyZQGKOJJlxr36Evoas26C1Aj3_45arfSMYX_45QMeta || {},
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/tuition-exemption/stats-by-ward.vue")
  },
  {
    name: "tuition-exemption-stats-by-ward___en",
    path: "/en/tuition-exemption/stats-by-ward",
    meta: stats_45by_45wardbLVlSqZRyZQGKOJJlxr36Evoas26C1Aj3_45arfSMYX_45QMeta || {},
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/tuition-exemption/stats-by-ward.vue")
  },
  {
    name: "statistic-student-status-summary___vi",
    path: "/statistic/student-status-summary",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/statistic/student-status-summary.vue")
  },
  {
    name: "statistic-student-status-summary___en",
    path: "/en/statistic/student-status-summary",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/statistic/student-status-summary.vue")
  },
  {
    name: "tuition-exemption-parent-confirm___vi",
    path: "/tuition-exemption/parent-confirm",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/tuition-exemption/parent-confirm.vue")
  },
  {
    name: "tuition-exemption-parent-confirm___en",
    path: "/en/tuition-exemption/parent-confirm",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/tuition-exemption/parent-confirm.vue")
  },
  {
    name: "statistic-student-status-summary-old___vi",
    path: "/statistic/student-status-summary-old",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/statistic/student-status-summary-old.vue")
  },
  {
    name: "statistic-student-status-summary-old___en",
    path: "/en/statistic/student-status-summary-old",
    component: () => import("D:/W2/CDVM_V2/VM.Cms/pages/statistic/student-status-summary-old.vue")
  }
]